import { useQuery } from "@tanstack/react-query";

import { getFieldShape, getFieldShapeAdmin, getFieldShapes } from "services";

import { getEnvironment, getLocalKlimVar } from "utils";

import { DEFAULT_CACHE_TIME, GET_FIELD_SHAPE, GET_FIELD_SHAPES } from "consts";

import { FieldShape } from "models";

export const useGetFieldShapes = () => {
  const farmId = getLocalKlimVar("farmId");

  const { data, isLoading } = useQuery<{ fieldShapes: FieldShape[] | [] }>({
    queryKey: [GET_FIELD_SHAPES, farmId],
    queryFn: getFieldShapes,
    gcTime: DEFAULT_CACHE_TIME * 7, // 7 days stale time
    staleTime: DEFAULT_CACHE_TIME * 7, // 7 days stale time
  });

  return { fieldShapes: data?.fieldShapes || [], fieldShapesLoading: isLoading };
};

export const useGetFieldShape = ({ type, fieldId, highQuality = false }: { type?: string; fieldId: string; highQuality?: boolean }) => {
  const farmId = getLocalKlimVar("farmId");

  const isAdmin = getEnvironment().admin;

  const { data, isLoading } = useQuery({
    queryKey: [GET_FIELD_SHAPE, fieldId, type, isAdmin, highQuality],
    queryFn: () => (isAdmin ? getFieldShapeAdmin({ fieldId, type }) : getFieldShape({ fieldId, type, highQuality })),
    enabled: !!fieldId && !!farmId,
    gcTime: DEFAULT_CACHE_TIME * 7, // 7 days stale time
    staleTime: DEFAULT_CACHE_TIME * 7, // 7 days stale time
  });

  return {
    fieldShape: data?.fieldShape,
    fieldShapeLoading: isLoading,
  };
};
